<template>
  <div class="relevance-pic container">
    <!--    {{ detail.software_water_pic }}-->
    <div class="btn" v-if="detail.used_pic.length"

    >
      关联素材
      <div class="used_pic-box" :class="[ detail.used_pic.length > 2 ? 'more': 'one' ]" >
        <HappyScroll hide-horizontal resize>
          <div class="favorites-list">
            <a
              :href="MATERIAL_DETAIL + '/' + item.uniq_id + '.html'"
              target="_blank"
              v-for="item in detail.used_pic"
              :key="item.proto_pic">
              <img :src="IMG_BASE_URL + item.proto_pic + '!/fw/572/quality/90/unsharp/true/compress/true'">
            </a>
          </div>
          <div class="no-more" v-show="isEnd">您还没有更多收藏的素材~</div>
        </HappyScroll>
      </div>
    </div>
    <div class="btn" v-if="detail.software_water_pic"
    >原创过程证明

      <el-image
        class="el-image"
        :src="src"
        :preview-src-list="imgList"/>

    </div>


  </div>
</template>

<script>
import {MATERIAL_DETAIL, IMG_BASE_URL} from "@/constant/PATH";
import {HappyScroll} from 'vue-happy-scroll';
// 引入css，推荐将css放入main入口中引入一次即可。
import 'vue-happy-scroll/docs/happy-scroll.css'

export default {
  name: "relevance-pic",
  props: {
    /* 详情 */
    detail: {
      type: Object,
      default: () => {

      }
    },
  },
  components: {
    HappyScroll
  },
  data() {
    return {
      IMG_BASE_URL,
      MATERIAL_DETAIL,
      imgList: [],
      isShow: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.priviewPic();
    }, 500)
  },
  methods: {
    priviewPic() {
      this.src = IMG_BASE_URL + this.detail.software_water_pic;
      this.imgList.push(this.src)
    }

  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  .btn {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 20px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #E0E3E9;
    margin-right: 20px;
    font-size: 14px;
    color: #596088;
    line-height: 32px;
    position: relative;
    cursor: pointer;

    .el-image {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0;
      z-index: 5;
    }

    &:hover {
      color: $color-primary;
      border-color: $color-primary;

      .used_pic-box {
        display: flex;
      }

      &:after{
        height: 200px;
      }
    }

    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      width: 100%;
      //left: 50%;
      //top: 50%;
      left: -10px;
      bottom: 0;
      //padding: 100px 0 0 10px;
      height: 0px;
      //transform: translate(-50%, -50%);
      background: transparent;
    }


    .used_pic-box {
      width: 342px;
      max-height: 430px;
      height: 430px;
      background: #FFFFFF;
      box-shadow: 0px 2px 8px 0px rgba(10, 37, 64, 0.1);
      border-radius: 10px;
      @include Position(1, 4, -346px, 0);
      //padding: 14px 14px 0;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      display: none;

      /deep/.happy-scroll-container{
        width: 100% !important;
        height: 100%  !important;
        box-sizing: border-box;
        //overflow-y: hidden;
        ::-webkit-scrollbar {
          width: 0;
          background-color: transparent;
        }
      }

      &.one {
        height: 220px;
      }

      &.more {
        height: 430px;
      }

      a {
        display: inline-block;
        width: 150px;
        height: 194px;
        border-radius: 6px;
        margin: 0 14px 14px 0;
        overflow: hidden;

        &:hover {
          img {
            transform: scale(1.1);
          }
        }

        img {
          display: inline-block;
          width: 100%;
          height: 100%;
          transition: all 0.5s ease-in-out;
        }

        &:nth-child(2n) {
          margin-right: 0;
        }

      }

    }

  }
}

.favorites-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 14px 14px 0;
  box-sizing: border-box;

  a {

    display: inline-block;
    width: 150px;
    height: 194px;
    border-radius: 6px;
    margin: 0 14px 14px 0;
    overflow: hidden;

    img {
      display: inline-block;
      width: 100%;
      height: 100%;
    }

    &:nth-child(4) {
      margin-right: 0;
    }
  }
}
</style>
